import axios from 'axios'

const base_url = `${process.env.VUE_APP_API_PATH}`;

export default {
    getTaxiTypes(payload) {
        const url = `${base_url}/taxi-types`;

        return axios.post(url, payload)
    },


    addTaxiCompany(payload) {
        const url = `${base_url}/taxi-types/create`;

        return axios.post(url, payload)
    },


    updateTaxiCompany(payload){
        const url = `${base_url}/taxi-types/update`;

        return axios.put(url, payload)
    },

    AddTaxiDriver(payload){
        const url = `${base_url}/taxi-types/driver`;

        return axios.post(url, payload)
    },
    getRequests(user_email){
        const url = `${base_url}/requests/all`;
        return axios.post(url, user_email)
    },


}
